import React, { useState } from "react";
import {
  Box,
  Drawer,
  SwipeableDrawer,
  // Tab,
  // Tabs,
  Toolbar,
} from "@mui/material";

import styled from "@emotion/styled";

import "./Sidebar.css";

// import AppVerticalBarChart from '../AppVerticalBarChart/AppVerticalBarChart';
import SidebarTable from "../SidebarTable/SidebarTable";
import CustomDateFilter from "../CustomDateFilter/CustomDateFilter";
import CustomUserFilter from "../CustomUserFilter/CustomUserFilter";
import { useSelector } from "react-redux";
import { Tabs, Tab, Card, CardBody, Accordion, AccordionItem } from "@nextui-org/react";

function Sidebar(props) {
  const [expandedSetDate, setExpandedSetDate] = useState(false);
  const [expandedSetUsers, setExpandedSetUsers] = useState(false);

  const userData = useSelector((state) => state.user.value);

  const handleDateAccordionChange = (event) => {
    // if (expandedSetDate)
    // {
    //   props.handleTimeframeChange('week')
    // }
    // else
    // {
    //   props.handleTimeframeChange('custom')
    // }
    setExpandedSetDate(!expandedSetDate);
  };

  const handleUsersAccordionChange = (event) => {
    setExpandedSetUsers(!expandedSetUsers);
  };

  const handleStartDateChange = (newDate) => {
    props.setStartDate(newDate);
  };

  const handleEndDateChange = (newDate) => {
    props.setEndDate(newDate);
  };

  const handleTabTimeframeChange = (event, newValue) => {
    if (expandedSetDate) {
      setExpandedSetDate(false);
    }
    props.handleTimeframeChange(newValue);
  };

  // const CustomTabs = styled(Tabs)({
  //   "& .MuiTabs-indicator": {
  //     backgroundColor: "var(--sidebar-color)",
  //   },
  // });

  // const CustomTab = styled(Tab)({
  //   color: "white",
  //   fontSize: "1vw",
  //   fontFamily: "var(--primary-font-family)",
  //   minWidth: "33%",
  //   backgroundColor: "var(--primary-color)",
  //   "&.Mui-selected": {
  //     color: "var(--sidebar-color)",
  //   },
  // });

  const handleSelectChange = (newValue) => {
    props.handleDashTypeChange(newValue);
  };

  const handleRangeChange = (range) => {
    props.handleTimeframeChange(range);
  };

  // const CustomInput = styled(InputBase)(() => ({
  //   '& .MuiInputBase-input': {
  //     borderRadius: 4,
  //     backgroundColor: 'white',
  //     border: '1px solid black',
  //     fontSize: '1vw',
  //     padding: '10px 26px 10px 12px',
  //     textAlign: "start",
  //     '&:focus': {
  //       borderRadius: 4,
  //       borderColor: 'white',
  //     },
  //   },
  // }));

  const drawer = (
    <Box
      sx={{
        // backgroundColor: "var(--sidebar-color)",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        ".MuiToolbar-root": { minHeight: "64px" },
      }}
    >
      <Toolbar sx={{ flex: "0 1 auto" }} />
      {/* {props.dasshType !== undefined &&  */}
      {/* <div className='sidebar-dash-select'>
              <FormControl fullWidth>
                <InputLabel sx = {styles.inputLabel}>Dashboard</InputLabel>
                <Select
                  sx = {styles.selectInput}
                  value={props.dashType}
                  label="Dashboard"
                  onChange={handleSelectChange}
                  size = {'small'}
                  // input = {<CustomInput/>}
                >
                  <MenuItem value={'normal'}>Normal</MenuItem>
                  {userData.role === "manager" && <MenuItem value={'recruiting'}>Recruiting</MenuItem>}
                </Select>
              </FormControl>
            </div> */}
      {/* <div className='sidebar-header'>Dashboard</div> */}

      <div className="sidebar-dash-select">
        {/* <Tabs
          value={props.dashType}
          onChange={handleSelectChange}
          variant={"fullWidth"}
          sx={styles.tabs}
        >
          <Tab value={"normal"} label={"Core Four"} sx={styles.tab} />
          {(userData.role === "manager" || userData.role === "admin") && (
            <Tab value={"recruiting"} label={"Recruiting"} sx={styles.tab} />
          )}
        </Tabs> */}
        <Tabs onSelectionChange={handleSelectChange} fullWidth size="md" aria-label="Options">
          <Tab key="normal" title="Core Four" />
          {(userData.role === "manager" || userData.role === "admin") && (
            <Tab key="recruiting" title="Recruiting" />
          )}
        </Tabs>
      </div>

      {/* <div className='sidebar-header'>Filters</div> */}
      <Accordion>
        <AccordionItem key="1" aria-label="date-range" title="Date Range">
          <CustomDateFilter
            expandedSetDate={expandedSetDate}
            handleAccordionChange={handleDateAccordionChange}
            handleRangeChange={handleRangeChange}
            startDate={props.startDate}
            endDate={props.endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            rangeValue={props.timeframe}
          />
        </AccordionItem>
        <AccordionItem key="2" aria-label="team-members" title="Team Members">
          <CustomUserFilter
            expandedSetUsers={expandedSetUsers}
            handleAccordionChange={handleUsersAccordionChange}
            users={props.users}
            userFilter={props.userFilter}
            toggleUserFilter={props.toggleUserFilter}
            toggleAllUserFilter={props.toggleAllUserFilter}
          />
        </AccordionItem>
      </Accordion>

      {/*             
            <div className='sidebar-tabs' sx = {{flex: "0 1 auto"}} >
                <CustomTabs value={props.timeframe} onChange={handleTabTimeframeChange} variant = "fullWidth">
                    <CustomTab label="Week" value={'week'} />
                    <CustomTab label="Month" value={'month'}/>
                    <CustomTab label="Year" value={'year'} />
                </CustomTabs>
            </div> */}
    </Box>
  );

  return (
    <Drawer
      sx={{
        width: "var(--sidebar-width)",
        zIndex: 30,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: "var(--sidebar-width)",
          boxSizing: "border-box",
          border: "none",
          boxShadow: "10px 0px 19px -1px rgba(0,0,0,0.15)",
          background: 'white',
        },
      }}
      // variant="permanent"
      anchor="left"
      open={props.open}
      onClose={props.handleDrawerToggle}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      {/* <div>123</div> */}
      {drawer}
    </Drawer>
  );
}

const styles = {
  selectInput: {
    fontSize: "1vw",
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primary-color)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primary-color)",
    },
  },
  inputLabel: {
    "&.Mui-focused": {
      color: "var(--primary-color)",
    },
  },
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "var(--sidebar-color)",
    },
  },
  tab: {
    color: "white",
    fontSize: "1vw",
    fontFamily: "var(--primary-font-family)",
    minWidth: "33%",
    backgroundColor: "var(--primary-color)",
    "&.Mui-selected": {
      color: "var(--sidebar-color)",
    },
  },
};

export default Sidebar;
